<template>
   <AccountProfileField
      v-if="address"
      :title="field.label"
      :details="address"
      :fieldNotice="field.fieldNotice"
      data-cy="account-profile-address"
   />
</template>
<script setup lang="ts">
import type { AccountProfileField } from "@/components/account/accountTypes";
import { useUserStore } from "@/stores/userStore";

const userStore = useUserStore();

// Props
// ------------------------------------
const props = defineProps<{
   field: AccountProfileField;
}>();

// Computed
// ------------------------------------
const address = computed(() => {
   if (!userStore.user?.address) return null;

   const addressElements = [
      userStore.user.address.line_1,
      userStore.user.address.line_2,
      userStore.user.address.city,
      userStore.user.address.region,
      userStore.user.address.postalCode,
      userStore.user.address.country,
   ];

   // Filter out empty elements and join existing ones with a comma
   return addressElements.filter((el) => el).join(", ");
});
</script>
